import React from "react";

// Shared context for workflow item reordering (drag & drop)
const ReorderContext = React.createContext({
  reorder: () => {},
  dragStart: () => {},
});

export default ReorderContext;
